import React from "react";
import { useOrderDescription } from "../useOrderDescription";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";
import { Box } from "@UI/Components/Box/Box";
import { ItemLine } from "./ItemLine";
import { Rate } from "@Shared/Components/Rate/Rate";
import { Bold } from "@UI/Components/Bold/Bold";

export const SubscriptionItem = ({ order, handleRemoveSubscription }) => {
  const { subscription } = useOrderDescription(order);

  return (
    <>
      {subscription.length > 0 && (
        <ItemLine
          title={
            <Box display="flex" flexDirection="column">
              <FormattedMessage
                {...messages[subscription[0]?.item?.name]}
                values={{
                  name: subscription[0]?.item?.name,
                }}
              />
              <Box
                color="gray.500"
                textDecoration="underline"
                _hover={{ cursor: "pointer" }}
                onClick={handleRemoveSubscription}
              >
                <FormattedMessage {...messages.remove} />
              </Box>
            </Box>
          }
          amount={
            <Bold>
              <Rate
                cents={subscription[0]?.itemPriceCents}
                unit={subscription[0]?.itemBillingUnit}
                currency={subscription[0]?.itemPriceCurrency}
              />
            </Bold>
          }
          style={{ borderTopWidth: 0 }}
        ></ItemLine>
      )}
    </>
  );
};
